import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import Images from "../../../assets";
import { setWordCase } from "../../../assets/library";

const Family = (props: any) => {
  return (
    <div>
      <Typography
        sx={{
          background: "#FCF1EE",
          width: "fit-content",
          p: 1,
          borderRadius: "10px",
          mb: 2,
        }}
      >
        Family Details
      </Typography>
      {props.data?.length > 0
        ? props.data.map((item:any, i:number) => (
            <Grid
              container
              sx={{ boxShadow: 3, p: 2, borderRadius: "10px" }}
              key={i}
            >
              <Grid item xs={6} sx={{ display: "flex", p: 1 }}>
                <Grid container>
                  <Grid item xs={6}>
                    <Typography
                      sx={{
                        minWidth: 150,
                        color: "#7C7A7A",
                        fontSize: "14px",
                      }}
                    >
                      Family Relation
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography>{setWordCase(item.RelationshipWithStudent)}</Typography>
                  </Grid>
                </Grid>
              </Grid>
             
              <Grid item xs={6} sx={{ display: "flex", p: 1 }}>
                <Grid container>
                  <Grid item xs={6}>
                    <Typography
                      sx={{
                        minWidth: 150,
                        color: "#7C7A7A",
                        fontSize: "14px",
                      }}
                    >
                      First Name

                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography>{setWordCase(item.GuardianFirstName)}</Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={6} sx={{ display: "flex", p: 1 }}>
                <Grid container>
                  <Grid item xs={6}>
                    <Typography
                      sx={{
                        minWidth: 150,
                        color: "#7C7A7A",
                        fontSize: "14px",
                      }}
                    >
                      Last Name

                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography>{setWordCase(item.GuardianLastName)}</Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={6} sx={{ display: "flex", p: 1 }}>
                <Grid container>
                  <Grid item xs={6}>
                    <Typography
                      sx={{
                        minWidth: 150,
                        color: "#7C7A7A",
                        fontSize: "14px",
                      }}
                    >
                      Email ID
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography>{item.GuardianEmail ? item.GuardianEmail:"N/A"}</Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={6} sx={{ display: "flex", p: 1 }}>
                <Grid container>
                  <Grid item xs={6}>
                    <Typography
                      sx={{
                        minWidth: 150,
                        color: "#7C7A7A",
                        fontSize: "14px",
                      }}
                    >
                      GuardianOccupation
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography>{item.GuardianOccupation}</Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={6} sx={{ display: "flex", p: 1 }}>
                <Grid container>
                  <Grid item xs={6}>
                    <Typography
                      sx={{
                        minWidth: 150,
                        color: "#7C7A7A",
                        fontSize: "14px",
                      }}
                    >
                      GuardianQualification
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography>{item.GuardianQualification}</Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          ))
        : 
        <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "200px",
              flexDirection: "column",
            }}
          >
            <img
              src={Images.noData}
              alt="noData"
              style={{ width: "70px", height: "70px", marginBottom: "1rem" }}
            />
            <Typography>No data </Typography>
          </Box>}
    </div>
  );
};

export default Family;
